export enum SaleType {
    Sale = 'sale',
    Rent = 'rent',
}
